export const TRANSCRIPT_TEXT = `
[01:27] David Yozzi: The new product launch training, it kind of just folds right into the curriculum that you have running over here, right? Is that making sense?
[01:39] Melyssa Scott: It does, it does. So we have kind of like the... that’s where I think I got maybe a little confused. We have the phase one here which follows under the program architecture and then if I scroll down... We’re at the very end, continuous learning and new product launches.
[01:58] David Yozzi: Exactly. Look at that. There it is. Yep.
[02:02] Melyssa Scott: OK. So there’s... they’re separate yet intertwined... which we have to have different templates for per se. OK. And so cause I was going through all of this and you wanted like a 3 by 4 matrix per se... and when we’re going through like asset creation on that, are we looking at like different pitch decks per role?
[02:32] David Yozzi: So the way I think about it is a product is a product, right? So the product is the same to an AE that it is to a product specialist... I don't expect you to sort of sit there and list every single product for every role, but I expect you to be able to categorize them somewhat reasonably so that it makes sense. From the perspective of like what I need to do and what I need to finish. 
[04:20] Melyssa Scott: I believe I was told 2600 so.
[04:23] David Yozzi: Yeah, yeah, nobody’s gonna know 2600 products... But look, we have this really great asset around Techwatcher... we could turn that into a easy e-learning. Or a webinar... What I want you to think about is... what are the strategic things? What are the strategic products that we really sell a lot of?
[05:34] David Yozzi: The other thing I would say... e-learning is a great vehicle to do that through. You build the asset, it sits in an LMS and it’s accessed anytime, anywhere. So I don’t know the answer. The first thing I would do if I were you is start to map, sort of build the map we just talked about. Where you have that matrix roles and products above.
[06:27] Melyssa Scott: OK, OK. I have to learn about that cause I’m not super familiar with that other. So I yeah, I’ll definitely look into that. One other question I had... these all match what Revan has been requested to do as well, like align content by role.
[07:07] David Yozzi: Yeah. So where the overlap exists... when you think about what happens to sellers today... there’s pieces that are missing, like what’s the proper discovery around this product? What are potential objections? That’s where it aligns with what Revin is doing because Revin is focused on sales process, sales method, selling skills. You do it in context with something, right?
[08:31] Melyssa Scott: I think it’s more of a logistical piece of it. Are we both creating different SharePoint sites?
[08:33] David Yozzi: No, no, no, no. And by the way, I don’t see this as... well I do see product education as its own landing site, but I would see this fall more under your rubric than than his. So I don’t think he should be creating a duplicate of that. 
[09:23] Melyssa Scott: OK, I only ask because it’s under his as well... Launch SharePoint site that lays out product education journey for each role. So that’s why I wasn’t sure.
[09:36] David Yozzi: I probably got lazy. Yeah, I definitely got a little lazy here.
[11:28] David Yozzi: So yes... what I sent you was sort of a journey. Here again, I think we’re going to need to do crawl, walk, run, right. Crawl is maybe what you’re doing right now, which is essentially loading content into the LMS... let’s assume that’s going to be OK for at least through January, maybe February. But by March, let’s say for example, we want to be thinking about what’s V2 look like.
[14:45] David Yozzi: And I think I sent you... like an image of like four or five different people moving through this process over the course of time... Go to slide 9.
[17:23] Melyssa Scott: OK.
[17:24] David Yozzi: So this is actually fairly simple, right? What’s the goal? Acclimate. Get acclimated and up and running in your new role... Learn product portfolio... and you see the time frame is the first three weeks or actually first month. That’s a good way of starting to divide the content so that you can think about it in chunks.
[19:14] David Yozzi: Anyway, the image on this deck shows you a little bit more specifically like how you might map that out by content area... broken into self-serve, virtual, on the job activities, instructor led. Kind of cool huh? That’s an example of like a more advanced program. That wouldn’t be something we would do probably till late, late this year.
[22:09] Melyssa Scott: OK. OK. All right. Thank you for your time. I will pick your brain next week.
`;

export const MEETING_DATA = {
  id: "MTG-DEC17",
  title: "Product Ed & Curriculum Architecture",
  date: "Wednesday, Dec 17 • 2:41 PM",
  attendees: ["David Yozzi", "Melyssa Scott"],
  sentiment: "Clarifying & Strategic",
  summary:
    "David clarified the tension between Product Education (Melyssa) and Sales Skills (Revin). Melyssa explicitly owns the Product Education architecture. New product launches are not separate programs; they fold into this architecture. The immediate goal is a 'Crawl' phase (LMS content) with a 'Walk/Run' evolution planned for March (V2).",

  insights: [
    {
      id: "ownership-defined",
      label: "Ownership Defined",
      summary: "Melyssa owns the Product Education site/rubric, not Revin.",
      expanded: {
        paragraphs: [
          "This conversation explicitly resolved a long-standing ambiguity around ownership. While Product Education and Sales Enablement are adjacent, they are distinct systems.",
          "Melyssa is the architect for Product Education. Revin is the architect for Sales Skills/Process. They should reference each other, but not duplicate work.",
        ],
        bullets: {
          whyItMatters: [
            "Prevents duplicate SharePoint sites and conflicting content.",
            "Creates a single source of truth for sellers (Product vs. Process).",
            "Clarifies accountability for content gaps.",
          ],
          whatChanged: [
            "Product Education ownership is now explicitly under Melyssa’s rubric.",
            "Revin should focus on 'Applied' skills (Handling Objections, Negotiation).",
          ],
          risksIfIgnored: [
            "Seller confusion about where to find answers.",
            "Redundant content creation and version drift.",
          ],
        },
      },
    },
    {
      id: "system-over-duplication",
      label: "System over Duplication",
      summary:
        "New product launches are just modules that plug into the existing curriculum.",
      expanded: {
        paragraphs: [
          "There was a risk of treating 'New Product Launches' as a separate training vertical. David clarified that launches are episodic events that should fold into the continuous learning architecture.",
        ],
        bullets: {
          whyItMatters: [
            "Ensures longevity of content (Launch content becomes Evergreen content).",
            "Reduces the 'Campaign' mentality in favor of 'Curriculum' mentality.",
          ],
          enables: [
            "Faster onboarding for future hires (they just take the module).",
            "Clean alignment with the LMS structure.",
          ],
          nextSteps: [
            "Slot the 'Trevi' Launch into the framework immediately.",
            "Define where launch assets live after the launch week ends.",
          ],
        },
      },
    },
    {
      id: "v1-vs-v2",
      label: "V1 vs V2 (Crawl/Walk/Run)",
      summary:
        "'Crawl' is loading LMS content now (Jan/Feb). 'Walk' is Applied Product Ed (March).",
      expanded: {
        paragraphs: [
          "David set clear expectations to lower immediate pressure while setting a higher bar for the future. He does not expect a sophisticated role-based matrix immediately.",
        ],
        bullets: {
          whatChanged: [
            "Immediate goal: Load content to LMS (Basic Access).",
            "Future goal (March): Nuanced, role-based paths (Applied Learning).",
          ],
          risksIfIgnored: [
            "Over-engineering the V1 launch and missing the Jan deadline.",
            "Failing to plan for the V2 evolution, resulting in a static library.",
          ],
        },
      },
    },
    {
      id: "scope-control",
      label: "Scope Control",
      summary:
        "Do not build content for 2,600 products. Map strategic products to roles.",
      expanded: {
        paragraphs: [
          "The scale of the product portfolio (2,600 SKUs) is a trap. Success is not comprehensive coverage, but strategic prioritization.",
        ],
        bullets: {
          enables: [
            "High-quality deep dives on the products that drive revenue.",
            "Realistic workload management for the team.",
          ],
          nextSteps: [
            "Collaborate with Leadership to define the 'Strategic Product List'.",
            "Build the visual map: Roles (y-axis) vs Strategic Products (x-axis).",
          ],
          resources: [
            { title: "Curriculum Journey Deck (PPT)", href: "#" },
            { title: "Techwatcher Assets", href: "#" },
          ],
        },
      },
    },
  ],

  resources: [
    { label: "Curriculum Journey Deck (PPT)", type: "ppt", url: "#" },
    { label: "Techwatcher Assets", type: "file", url: "#" },
    { label: "Revin's Onboarding V2 Plan", type: "link", url: "#" },
  ],

  // --- UPDATED ACTIONS WITH VISUAL MOCKUPS ---
  actions: {
    her: [
      {
        text: "Build the Curriculum Map (Role x Product x Time)",
        status: "urgent",
        examples: [
          {
            title: "Example A: Role x Time Learning Journey",
            tag: "Visual Map",
            description:
              "A visual, horizontal journey showing Roles vs Time Phases (Week 1, Month 1, etc).",
            why: "Best for executive alignment and onboarding clarity. Shows progression without overwhelming detail.",
            when: "Explaining the system to leadership or aligning with Sales Enablement.",
            mockup: `[ Y-AXIS: ROLES ]
  --------------------------------------------------
  | Account Exec   |  [ Wk 1: Basics ] --> [ Mo 1: Buyer Personas ] --> [ Continuous ]
  | Prod Specialist|  [ Wk 1: Deep Dive ] --> [ Mo 1: Tech Specs ] --> [ Certifications ]
  | CS Manager     |  [ Wk 1: Overview ] --> [ Mo 1: Adoption ] --> [ QBR Prep ]
  --------------------------------------------------
  * Visualizes time progression horizontally`,
          },
          {
            title: "Example B: Role x Product Coverage Matrix",
            tag: "Lightweight",
            description:
              "A grid where Rows = Roles, Columns = Product Categories. Cells = Required/Optional.",
            why: "Directly solves the '2,600 products' problem by focusing on relevance, not exhaustiveness.",
            when: "Deciding what NOT to build and prioritizing investment.",
            mockup: `[ MATRIX VIEW ]
  --------------------------------------------------
  | ROLE          |  CORE PLATFORM  |  ADD-ON MODULES  |  LEGACY TOOLS  |
  |---------------|-----------------|------------------|----------------|
  | AE            |    REQUIRED     |     OPTIONAL     |   AWARENESS    |
  | Prod Spec     |    EXPERT       |     REQUIRED     |   OPTIONAL     |
  | SDR           |    BASIC        |     NONE         |   NONE         |
  --------------------------------------------------
  * Focuses on scope control`,
          },
          {
            title: "Example C: Curriculum Index Page",
            tag: "Navigation First",
            description:
              "A mock 'Product Education Home' page with links fanning out by time and category.",
            why: "Models the end-user experience without needing content built yet.",
            when: "Testing usability assumptions and preventing SharePoint sprawl.",
            mockup: `[ HOMEPAGE WIREFRAME ]
  --------------------------------------------------
  |  Welcome to Product Ed  |  [ Search Bar ]      |
  --------------------------------------------------
  |  CHOOSE YOUR PATH:                             |
  |  [ I am an AE ]   [ I am a Specialist ]        |
  |                                                |
  |  BROWSE BY CATEGORY:                           |
  |  [ Cloud ]  [ Security ]  [ Data ]             |
  --------------------------------------------------`,
          },
        ],
      },
      {
        text: "Define Role-Based Learning Expectations",
        status: "pending",
        examples: [
          {
            title: "Example A: Role Learning Charter",
            tag: "1-Pager",
            description:
              "A single-page role profile answering what is 'working knowledge' vs 'expert'.",
            why: "Extremely clear and easy to socialize. Low maintenance.",
            when: "Onboarding new hires or setting certification expectations.",
            mockup: `[ ROLE PROFILE: ACCOUNT EXECUTIVE ]
  --------------------------------------------------
  | EXPECTATION LEVEL:                             |
  | 1. Pitch: Expert (Must pass video cert)        |
  | 2. Technical: Working Knowledge (Know who to ask)|
  | 3. Pricing: Expert                             |
  |                                                |
  | "You are not expected to demo the API."        |
  --------------------------------------------------`,
          },
          {
            title: "Example B: Role Readiness Checklist",
            tag: "Outcome Based",
            description:
              "A checklist like 'Can explain core value prop' or 'Can identify primary buyer'.",
            why: "Shifts learning from consumption to outcomes.",
            when: "Designing assessments or supporting managers.",
            mockup: `[ READINESS CHECKLIST ]
  [ ] Can identify the 3 target buyer personas
  [ ] Can articulate the "Speed to Market" differentiator
  [ ] Knows where to find the pricing calculator
  [ ] Has completed the " Competitor Battlecard" review`,
          },
        ],
      },
      {
        text: "Document boundaries between Product Ed & Sales Skills",
        status: "pending",
        examples: [
          {
            title: "Example A: 'Who Owns What' Boundary Doc",
            tag: "Table",
            description:
              "A simple table: Topic | Product Ed Owns? | Sales Skills Owns? | Shared?",
            why: "Fastest way to stop scope creep.",
            when: "Resolving future disagreements or onboarding stakeholders.",
            mockup: `[ OWNERSHIP MATRIX ]
  --------------------------------------------------
  | TOPIC           | PRODUCT ED (Melyssa)| SALES SKILLS (Revin)|
  |-----------------|---------------------|---------------------|
  | Value Prop      |       OWNER         |      Consulted      |
  | Negotiation     |       ---           |      OWNER          |
  | Handling Objections|    Content       |      Technique      |
  | Demo Flow       |       Shared        |      Shared         |
  --------------------------------------------------`,
          },
          {
            title: "Example B: End-to-End Seller Learning Flow",
            tag: "Diagram",
            description:
              "A flow diagram showing handoff points: Product Ed -> Applied Context -> Sales Skills.",
            why: "Shows collaboration instead of separation.",
            when: "Aligning teams and explaining the system to sellers.",
            mockup: `[ LEARNING FLOW ]
  (Product Ed)          (Applied Context)       (Sales Skills)
  [ What is it? ]  -->  [ Who buys it? ]  -->   [ How to Close? ]
        ^                      ^                       ^
  (Technical Docs)      (Battlecards)           (Roleplay/Coaching)`,
          },
        ],
      },
      {
        text: "Slot 'Trevi' Launch into framework",
        status: "pending",
        examples: [
          {
            title: "Example A: Trevi Launch Module",
            tag: "Curriculum View",
            description:
              "A mock module showing where Trevi appears in onboarding vs continuous learning.",
            why: "Demonstrates the system working in real life.",
            when: "Pressure-testing the framework.",
            mockup: `[ CURRICULUM INSERTION POINT ]
  ...
  Module 3: Core Platform
  Module 4: Security Add-ons
     > [NEW] Trevi Launch Module (Required) <
  Module 5: Legacy Systems
  ...`,
          },
          {
            title: "Example B: Trevi vs Core Overlay",
            tag: "Visual",
            description:
              "A visual overlay showing what is new vs reused content.",
            why: "Shows efficiency and reuse.",
            when: "Defending scope and communicating with leadership.",
            mockup: `[ CONTENT REUSE MAP ]
  [ Core Pitch Deck ]  <-- Reused (80%)
  [ Pricing Sheet ]    <-- Updated (10%)
  [ Trevi One-Pager ]  <-- NEW (10%)
  
  * Highlights efficiency: "We only built 10% new content"`,
          },
        ],
      },
    ],
    them: [
      { text: "Validate Melyssa's Curriculum Map", status: "pending" },
      { text: "Help prioritize 'Strategic Products' list", status: "pending" },
    ],
  },
};

export const WEEKS_DATA = [
  // --- DECEMBER 2025 ---
  {
    id: "WK-DEC15",
    date: "Dec 15 - 21",
    title: "Alignment Week",
    summary:
      "First full week in the FT seat. Major focus on defining the boundary between Product Education and Sales Enablement to avoid duplication.",
    tags: ["Alignment", "Strategy"],

    // MEETING CARD TRIGGER
    meetings: [
      {
        id: "MTG-DEC17",
        title: "Product Ed Architecture",
        with: "David Yozzi",
        date: "Dec 17",
        urgent: true,
      },
    ],

    deliverables: [
      {
        id: "d15_1",
        text: "Draft Curriculum Map (Role x Product)",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "d15_2",
        text: "Review 'Techwatcher' assets for LMS",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "d15_3",
        text: "Sync with Revin on 'Sales Skills' handoff",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "d15_5",
        text: "Kids' Holiday Concert Prep",
        type: "life",
        defaultChecked: true,
      },
      {
        id: "d15_6",
        text: "Grocery Run (Gluten Free Stuff)",
        type: "life",
        defaultChecked: false,
      },
    ],
  },
  {
    id: "WK-DEC22",
    date: "Dec 22 - 28",
    title: "Holiday Pause",
    summary:
      "Short week. Finalize the V1 LMS upload plan before checking out for the holidays.",
    tags: ["Rest", "Family"],
    deliverables: [
      {
        id: "d22_1",
        text: "Upload Phase 1 Content to LMS",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "d22_2",
        text: "Set OOO & Clear Inbox",
        type: "work",
        defaultChecked: false,
      },
      { id: "d22_3", text: "Wrap Gifts", type: "life", defaultChecked: false },
      {
        id: "d22_4",
        text: "Family Dinner Planning",
        type: "life",
        defaultChecked: false,
      },
    ],
  },
  {
    id: "WK-DEC29",
    date: "Dec 29 - Jan 04",
    title: "Deep Work Mode",
    summary:
      "Quiet week. Perfect time to build the visual 'Map' David asked for without interruptions.",
    tags: ["Deep Work", "Prep"],
    deliverables: [
      {
        id: "d29_1",
        text: "Design Visual Curriculum Map (Slide)",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "d29_2",
        text: "Identify 'Strategic Products' for V1",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "d29_3",
        text: "Date Night (No Kids)",
        type: "life",
        defaultChecked: false,
      },
      {
        id: "d29_4",
        text: "Clean out the garage",
        type: "life",
        defaultChecked: false,
      },
    ],
  },
  // --- JANUARY 2026 ---
  {
    id: "WK-JAN05",
    date: "Jan 05 - 11",
    title: "V1 Launch Prep",
    summary:
      "Getting the 'Crawl' phase ready for rollout. Ensuring the LMS paths are active.",
    tags: ["High Priority", "Strategy"],
    deliverables: [
      {
        id: "jan05_1",
        text: "Test LMS Learning Paths (QA)",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "jan05_2",
        text: "Present Curriculum Map to David",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "jan05_3",
        text: "Distribute Pre-read materials",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "jan05_4",
        text: "School Drop-offs (Tue/Thu)",
        type: "life",
        defaultChecked: false,
      },
      {
        id: "jan05_5",
        text: "Book Doctor Appts",
        type: "life",
        defaultChecked: false,
      },
    ],
  },
  {
    id: "WK-JAN12",
    date: "Jan 12 - 18",
    title: "Execution Mode",
    summary:
      "V1 is live. Moving focus to the 'Walk' phase (Applied Product Ed) for March.",
    tags: ["Execution", "Momentum"],
    deliverables: [
      {
        id: "jan12_1",
        text: "Launch V1 Product Ed Tracks",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "jan12_2",
        text: "Send Follow-up Action Items",
        type: "work",
        defaultChecked: false,
      },
      {
        id: "jan12_3",
        text: "Meal Prep Sunday",
        type: "life",
        defaultChecked: false,
      },
    ],
  },
];
